import { createContext } from 'react';

export const CategoryContext = createContext();

export default CategoryContext;
